import LayoutWrapper from '@/features/orders/components/Tabs/parts/LayoutWrapper'
import SearchTabsBar from '@/features/pos/components/Tabs/parts/SearchTabsBar'
import { usePosActiveScreen } from '@/features/pos/hooks/usePosActiveScreen'
import TopTabs from '@/features/ui/components/TopTabs'
import { Tab } from '@/features/ui/navigation'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Tabs: FC = () => {
    const { t } = useTranslation()

    const posScreen = usePosActiveScreen()

    const shouldHideTabs = posScreen === 'order-finalization'

    return (
        <TopTabs
            {...(shouldHideTabs
                ? { tabBar: () => null }
                : {
                      tabBar: (props) => (
                          <SearchTabsBar activeScreen={posScreen} topTabBarProps={props} />
                      ),
                  })}
            layout={({ children }) => <LayoutWrapper>{children}</LayoutWrapper>}
            screenOptions={{ swipeEnabled: false }}
        >
            <TopTabs.Screen
                name="(pos)"
                options={{
                    tabBarLabel: ({ focused }) => <Tab active={focused}>{t('posTabs.all')}</Tab>,
                }}
            />
        </TopTabs>
    )
}

export default Tabs
